import { useMutation } from '@apollo/client/react';
import { Button, Modal } from 'antd';
import React from 'react';
import { DELETE_REGISTER_FORM_FIELD } from '../../../../../graphql/Mutation';

const DeleteTableFieldModal = ({
  showModal,
  setShowModal,
  selectedField,
  setSelectedField,
  handleRefetch,
}) => {
  const [deleteRegisterFormField, { loading: deleteLoading }] = useMutation(
    DELETE_REGISTER_FORM_FIELD,
    {
      onError() {},
      onCompleted: () => {
        setShowModal(false);
        setSelectedField();
        handleRefetch();
      },
    },
  );
  const handleOk = () => {
    deleteRegisterFormField({
      variables: {
        id: selectedField?.id,
      },
    });
  };
  const handleCancel = () => {
    setShowModal(false);
    setSelectedField();
  };
  return (
    <div>
      <Modal
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2>Delete Field</h2>
        <p>Are you sure you want to delete the field {selectedField?.name} ?</p>
        <div className="form-buttons">
          <Button
            id="delete-table-field-cancel-btn"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
            disabled={deleteLoading}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-table-field-confirm-btn"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
            loading={deleteLoading}
          >
            Yes, Delete
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteTableFieldModal;
